export default __webpack_public_path__ + "static/media/user-3-256.457c5315.png";